module.exports = __webpack_public_path__ + "static/media/ondrej-pechl-cv.eae4742e.pdf";